import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CycleSection from './components/CycleSection';
import MethodologySection from './components/MethodologySection';
import SolutionsSection from './components/SolutionsSection';
import AISection from './components/AISection';
import PricingSection from './components/PricingSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CycleSection />
        <MethodologySection />
        <SolutionsSection />
        <AISection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
